import {StackActions, useNavigation} from '@react-navigation/native';
import React from 'react';
import {Linking} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import {Header} from '../../../components/Interface/Headers/Header';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {Button as ButtonFooter} from '../../../components/Interface/Forms/Buttons/Button';

import {
  Container,
  Content,
  ButtonContainer,
  Button,
  ButtonText,
  Footer,
  TextSpotlight,
  FooterButtonContainer,
} from './styles';

export function UserCreditCardNotEligible() {
  const navigation = useNavigation();
  const popAction = StackActions.pop(2);

  return (
    <Container>
      <Header
        icon="chevron-left"
        action={() => navigation.dispatch(popAction)}
      />
      <Content>
        <Titles
          title="Sua conta ainda não está pronta para compras com cartão de crédito."
          subtitle="Ainda estamos analisando sua conta."
        />
        <TextSpotlight>
          Enquanto isso, continue comprando por PIX.
        </TextSpotlight>
        <ButtonContainer>
          <Button
            activeOpacity={1}
            onPress={() =>
              Linking.openURL(
                'https://barataocombustiveis.com.br/termos-e-condicoes',
              )
            }>
            <ButtonText>Termos de uso do cartão de crédito</ButtonText>
          </Button>
        </ButtonContainer>
      </Content>
      <Footer>
        <SafeAreaView>
          <ButtonFooter
            title="Comprar por PIX"
            enabled
            onPress={() => navigation.dispatch(popAction)}
          />
          <FooterButtonContainer>
            <Button
              activeOpacity={1}
              onPress={() =>
                Linking.openURL('https://app.pipefy.com/public/form/GmdAAfB2')
              }>
              <ButtonText>Solicitar análise de crédito</ButtonText>
            </Button>
          </FooterButtonContainer>
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
